module.exports = __webpack_public_path__ + "img/wincal_MH_description.0d7ae920.jpg";